/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

(function() {
  // Open external links in new tab
  var links = document.links; 
  for (let i = 0, linksLength = links.length; i < linksLength; i++) {
    if (links[i].hostname !== window.location.hostname) { 
      links[i].target = '_blank';
      links[i].rel = 'noreferrer noopener';
    } 
  }

  // Wait for everything to load including theme JS
  window.addEventListener('load', function() {
    setTimeout(function() {
      // Open accordions marked to open by default
      document.querySelectorAll('[data-accordion-open="true"]').forEach(function(accordion) {
        var trigger = accordion.querySelector('[data-collapsible-trigger]');
        if (trigger) {
          trigger.click();
        }
      });
    }, 500);
  });

  // Accordion read more toggle
  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('[data-read-more]').forEach(function(button) {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var content = this.previousElementSibling;
        if (content) {
          content.classList.toggle('is-expanded');
          this.classList.toggle('is-expanded');
          this.setAttribute('aria-expanded', this.classList.contains('is-expanded'));
        }
      });
    });
  });

})();